import MyExecutionMilestonesPage from "../../shared/project-execution-plan/MyExecutionMilestonesPage";

const SupervisorExecutionMilestonesPage = () => (
  <MyExecutionMilestonesPage role="Supervisor" />
);

export default SupervisorExecutionMilestonesPage;
